export default "assets/images/icons/home-cf546769.svg";